import "next/dist/server/web/globals";
import { adapter } from "next/dist/server/web/adapter";
// Import the userland code.
import * as _mod from "private-next-root-dir/src/middleware.ts";
const mod = {
    ..._mod
};
const handler = mod.middleware || mod.default;
const page = "/src/middleware";
if (typeof handler !== "function") {
    throw new Error(`The Middleware "${page}" must export a \`middleware\` or a \`default\` function`);
}
export default function nHandler(opts) {
    return adapter({
        ...opts,
        page,
        handler
    });
}

//# sourceMappingURL=middleware.js.map